import { render, staticRenderFns } from "./MySpacesChild.vue?vue&type=template&id=699b8499&"
import script from "./MySpacesChild.vue?vue&type=script&lang=js&"
export * from "./MySpacesChild.vue?vue&type=script&lang=js&"
import style0 from "./MySpacesChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports